
import { defineComponent, computed } from 'vue'
export default defineComponent({
  name: 'ClientRebootModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    }
  },
  emits: ['closeClientModal', 'restartTer'],
  setup (props, context) {
    const modalVisiable = computed(() => props.show)
    return {
      modalVisiable,
      closeModal () {
        context.emit('closeClientModal', 'MODAL_CLIENT_REBOOT')
      },
      restartTerminal () {
        context.emit('restartTer')
        context.emit('closeClientModal', 'MODAL_CLIENT_REBOOT')
      }
    }
  }
})
